<div class="container gift-list-container">

    <div class="row justify-content-center">


            <div class="col-xs-12  col-sm-6  col-md-4  col-lg-3" *ngFor="let product of products">
                <div class='product'>
                    <div class='gift-title' style="position: absolute;">{{product.title}}</div>
                    <div class='image'>
                            <img loading="lazy" style='width:100%' src="http://classicapi.craftybymelissa.xyz/pics/{{product.smallPath}}" />
                    </div>
                </div>
            </div>
        

    </div>
</div>



